import { Box } from '@mui/material'

import styles from './index.module.scss'

export const PropertyDetailLabel = ({
  icon,
  amount,
  label,
  hasPluralForm = true,
}: {
  icon: React.ReactNode
  amount?: number | string
  label: string
  hasPluralForm?: boolean
}) => {
  let labelWithPlural = label
  const pr = new Intl.PluralRules('en-US')
  if (pr.select(Number(amount)) === 'other' && hasPluralForm) {
    labelWithPlural += 's'
  }

  return (
    <Box className={styles.propertiesItem}>
      <Box>{icon}</Box>
      <Box className={styles.propertiesLabel}>
        {amount} {labelWithPlural}
      </Box>
    </Box>
  )
}
